// {"call":"range_history_all","data":{"network":"signet","start_timestamp":1713832677,"end_timestamp":1745368677}}

import { Network } from '@/lib/networkConfig';
import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from './query-keys';
import { post, rangeByTimeSpan } from './api.helpers';
import { HistoryPagedResponse } from './api.types';
import { VALIDATOR_URL } from '@/constants';
import { VaultTransaction } from './types';
// import mock from './__test__/overview-new-indexer.json';

export function useQueryOverviewHistory(
  {
    network,
    limit,
    offset,
  }: {
    network: Network;
    limit: number;
    offset: number;
  },
  options = {}
) {
  const url = `${VALIDATOR_URL}/api/range_history_all`;

  const timestamp_end = Math.floor(Date.now() / 1000);
  const rangeSec = rangeByTimeSpan['1y'];
  const timestamp_start = timestamp_end - rangeSec;

  const params = {
    // network: 'Bitcoin',
    timestamp_start,
    timestamp_end,
    pagination: {
      limit,
      offset,
    },
  };

  return useQuery({
    queryKey: [QueryKeys.overviewHistory, network, limit, offset],
    queryFn: async () => {
      // const result = await mock.history;
      const response: HistoryPagedResponse<VaultTransaction> = await post(
        url,
        params
      );
      return {
        ...response,
        history: response.history.map((item) => ({
          ...item,
          //@ts-ignore
          action: actionMap[item.action] || item.action,
        })),
      };
    },
    staleTime: 1 * 60 * 1000,
    ...options,
  });
}

export const actionMap = {
  Open: 'o',
  Deposit: 'd',
  Withdraw: 'w',
  Borrow: 'b',
  Repay: 'r',
  Liquidation: 'l',
  Repossess: 'x',
  Reposes: 'x',
};

export const actionMapReverse = {
  'o': 'create',
  'd': 'deposit',
  'w': 'withdraw',
  'b': 'borrow',
  'r': 'repay',
  'l': 'liquidation',
  'x': 'repossess',
};

